import { Injectable, REQUEST, inject } from '@angular/core';
import { Route, Router } from '@angular/router';
import { StoreRedirects } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { FANDANKO_ROUTES, HERLIGHEDER_ROUTES } from './stores';

@Injectable({
  providedIn: 'root',
})
export class PermanentRedirectService {
  private router = inject(Router);

  requestUrl: string;

  constructor() {
    const request = inject(REQUEST, { optional: true });
    if (typeof window !== 'undefined') {
      this.requestUrl = window.location.host;
    } else {
      this.requestUrl = request?.headers.get('host') || environment.buildOrigin;
    }
  }

  public load() {
    switch (this.requestUrl) {
      case StoreRedirects.HERLIGHEDER:
        this.createRoutes(HERLIGHEDER_ROUTES);
        break;
      case StoreRedirects.FANDANKO:
        this.createRoutes(FANDANKO_ROUTES);
        break;
    }
  }

  private createRoutes(routes: Route[]) {
    const newRoutes = [...routes, ...this.router.config];
    this.router.resetConfig(newRoutes);
  }
}

export function permanentRedirectServiceFactory(redirectService: PermanentRedirectService) {
  return () => {
    return redirectService.load();
  };
}
